import React, { useEffect, useState } from 'react';
import { Grid, Typography, Box, useMediaQuery } from '@mui/material';
import { ContentBox, EmptyBox } from "../../libs/theme";
import REST from '../../libs/API';
import { formatDate, getText, trimString } from '../../libs/utils';
import { useTheme, styled } from '@mui/material/styles';
import {ArrowDown} from '../../assets/images/icons';

const MyGrid = styled(Grid)(({ theme }) => ({
  paddingBottom: '8px',
  marginBottom: '8px',
  "&:last-child": {
    paddingBottom: 0,
    marginBottom: 0
  },
  [theme.breakpoints.only('xs')]: {
    borderBottom: `1px solid ${theme.palette.primary.borderColor}`,
    paddingBottom: '25px',
    marginBottom: '25px',
    "&:last-child": {
      border: 0,
      paddingBottom: 0,
      marginBottom: 0
    }
  }
}))

const ArrowPager = styled(Box)(() => ({
  cursor: 'pointer',
  display: 'inline-block',
  margin: '0 7px',
  "&.prev": {
    transform: 'rotate(90deg)',
  },
  "&.next": {
    transform: 'rotate(-90deg)',
  },
  "&.disabled": {
    opacity: 0.4,
    pointerEvents: 'none'
  },
}))

const GridContent = styled(Typography)(({theme}) => ({
  [theme.breakpoints.only('xs')]: {
    fontWeight: '600',
    lineHeight: '26px'
  }
}))

const RefsIncome = ({ userToken, referalLink }) => {
  const theme = useTheme();
  let isXS = useMediaQuery(theme.breakpoints.only('xs'));
  const [refsData, setRefsData] = useState({data: [], pagination: {}});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getRefList();
  }, []);

  const getRefList = (page = 1) => {
    setLoading(true);
    REST.getReferalsList(userToken, {page}).then(( {data, pagination} ) => {
      setRefsData({data, pagination});
      setLoading(false);
    });
  }

  const {pagination, data} = refsData;
  return (
    <ContentBox sx={{ padding: '24px 32px 25px', minHeight: { lg: '440px', xs: '200px' } }}>
      {loading
        ? <span className="dot-spin centered"></span>
        : !data.length
          ? <EmptyBox sx={{ width: '380px' }}>
            <Typography>
              {getText('refChildNotFoundText')}
            </Typography>
            <Typography sx={{ color: 'secondary.main', fontWeight: 800, marginTop: '10px' }}>{`https://crypster.net${referalLink}`}</Typography>
          </EmptyBox>
          : <>
            {!isXS && <Grid container sx={{ margin: '0 0 24px' }}>
              <Grid item sm={2}>
                <Typography variant="boldCaption">№</Typography>
              </Grid>
              <Grid item sm={3}>
                <Typography variant="boldCaption">Email</Typography>
              </Grid>
              <Grid item sm={3}>
                <Typography variant="boldCaption">{getText('accRefAcrualHeaderDate')}</Typography>
              </Grid>
              <Grid item sm={3}>
                <Typography variant="boldCaption">{getText('accRefListHeaderActive')}</Typography>
              </Grid>
              <Grid item sm={1} sx={{textAlign: 'right'}}>
                {(pagination.pageCount > 1 && !isXS) && <>
                  {pagination.currentPage > 1 &&
                    <ArrowPager
                      className={`prev ${pagination.currentPage === 1 && ' disabled '}`}
                      onClick={() => getRefList(pagination.currentPage - 1)}
                    >
                      <ArrowDown />
                    </ArrowPager>
                  }
                  {pagination.pageCount > pagination.currentPage &&
                    <ArrowPager
                      className={`next ${pagination.pageCount === pagination.currentPage && ' disabled '}`}
                      onClick={() => getRefList(pagination.currentPage + 1)}
                    >
                      <ArrowDown />
                    </ArrowPager>
                  }
                </>}
              </Grid>
            </Grid>}

            {data.map((row, key) => (
              <MyGrid key={key} container>
                <Grid item sm={2} xs={6}>
                  <GridContent>{row.id}</GridContent>
                  {isXS && <Typography sx={{ fontSize: 12, color: "primary.grey", marginBottom: '13px' }}>№</Typography>}
                </Grid>
                <Grid item sm={3} xs={6}>
                  <GridContent>{isXS ? trimString(row.email, 6) : row.email}</GridContent>
                  {isXS && <Typography sx={{ fontSize: 12, color: "primary.grey", marginBottom: '13px' }}>Email</Typography>}
                </Grid>
                <Grid item sm={3} xs={6}>
                  <GridContent>{formatDate(new Date(row.created_at))}</GridContent>
                  {isXS && <Typography sx={{ fontSize: 12, color: "primary.grey" }}>{getText('accRefAcrualHeaderDate')}</Typography>}
                </Grid>
                <Grid item sm={4} xs={6}>
                  <GridContent>{row.isActiveReferral ? getText("accRefListActive") : getText("accRefListInactive")}</GridContent>
                  {isXS && <Typography sx={{ fontSize: 12, color: "primary.grey" }}>{getText('accRefListHeaderActive')}</Typography>}
                </Grid>
              </MyGrid>
            ))}

            {(pagination.pageCount > 1 && isXS) && <Box sx={{ textAlign: 'center' }}>
              {pagination.currentPage > 1 &&
                <ArrowPager
                  className={`prev ${pagination.currentPage === 1 && ' disabled '}`}
                  onClick={() => getRefList(pagination.currentPage - 1)}
                >
                  <ArrowDown />
                </ArrowPager>
              }
              {pagination.pageCount > pagination.currentPage &&
                <ArrowPager
                  className={`next ${pagination.pageCount === pagination.currentPage && ' disabled '}`}
                  onClick={() => getRefList(pagination.currentPage + 1)}
                >
                  <ArrowDown />
                </ArrowPager>
              }
            </Box>}

          </>
      }
    </ContentBox>
  )
}

export default RefsIncome